/**
 * Пауза перед повтором после неудачной попытки достать медиа.
 *
 * Одна на всех, кто повторяет: перевыпуск ссылки (`useMediaUrl`) и
 * перезапуск элемента слайда (ошибка и сторож простоя). Живёт в `media/`, а
 * не в `slides/`: её берёт и `media-url.ts`, а `media/` от `slides/` не
 * зависит.
 *
 * Нумерация: `attempt` это число уже сделанных попыток, и пауза после n-й
 * попытки это `retryDelayMs(n)`. Первая попытка идёт сразу, паузы перед ней
 * нет вовсе, и это забота зовущего, а не этой функции.
 *
 * Удвоение от 2 с с потолком 30 с: повтор через две секунды ловит короткий
 * обрыв, а лежащая сеть не получает запрос в секунду от каждого ученика.
 * Лимита попыток нет: урок идёт, пока идёт, и сдаться через минуту значило бы
 * оставить ученика с перезагрузкой страницы, от которой мы и уходим.
 */

const FIRST_DELAY_MS = 2000;
const MAX_DELAY_MS = 30_000;

export function retryDelayMs(attempt: number): number {
  // Ноль, отрицательное и NaN считаются первой попыткой: пауза не короче 2 с
  const n = Number.isFinite(attempt) ? Math.max(1, Math.floor(attempt)) : 1;
  return Math.min(MAX_DELAY_MS, FIRST_DELAY_MS * 2 ** (n - 1));
}
